import "./DaResetLinkExpired.css";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DaPageWrapper from "../DaPageWrapper/DaPageWrapper";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { translateStatic } from "../../hooks/useT/useT";

const DaResetLinkExpired = () => {
  return (
    <DaPageWrapper
      wrapperClass="da-msg-card da-page-wrapper"
      iconType="mail"
      title={<Translate tKey={T_KEYS.DA.RESET_LINK.TITLE} />}
      subtitle={
        <>
          {translateStatic(T_KEYS.DA.RESET_LINK.DESCRIPTION.PREFIX)}
          <br />
          name@email.com
        </>
      }
    >
      <Button variant="contained" fullWidth className="da-button da-link-expired-button">
        {translateStatic(T_KEYS.DA.LINK_EXPIRED.BUTTON.OPENMAIL)}
      </Button>

      <Typography variant="caption" color="text.secondary" className="da-msg-footer">
        {translateStatic(T_KEYS.DA.LINK_EXPIRED.FOOTER)}
      </Typography>
    </DaPageWrapper>
  );
};

export { DaResetLinkExpired };
